import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./footer.module.css";
import logo from "../../assets/logo.png";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
import { FaInstagram, FaWhatsapp, FaEnvelope } from "react-icons/fa";
/* One definition of the company's own accounts — this file used to hold a
 * handle of its own, and it disagreed with the schema's. */
import { INSTAGRAM_URL } from "../../seo/socialProfiles";

const SUPPORT_EMAIL = "hello@stylon.co";
const WHATSAPP_URL = "https://wa.me/972533920842";

const Footer = ({ accentColor }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar" || i18n.language === "he";
  const textAlign = isRtl ? "right" : "left";
  const flexDirection = isRtl ? "row-reverse" : "row";

  return (
    <footer
      className={styles.footerRoot}
      style={accentColor ? { background: accentColor } : undefined}
    >
      <section className={`container ${styles.footer_container}`}>
        <section style={{ textAlign: isRtl ? "right" : "left" }}>
          <Link to="/" aria-label="Stylon home">
            <img src={logo} className={styles.logo} alt="Stylon" />
          </Link>
        </section>
        <div className={styles.footer_child} style={{ flexDirection }}>
          <section className={styles.footer_about}>
            <div>
              <h3 style={{ textAlign }}>{t("footer.aboutUs")}</h3>
              <p style={{ textAlign }}>
                <span className={styles.about_text}>
                  <Link className={styles.link} to="/support">
                    {t("footer.customerSupport")}
                  </Link>
                </span>
              </p>
            </div>
          </section>
          <section className={styles.footer_about}>
            <div>
              <h3 style={{ textAlign }}>{t("footer.legalSection")}</h3>
              <p style={{ textAlign }}>
                <span className={styles.about_text}>
                  <Link className={styles.link} to="/terms-of-use">
                    {t("footer.termsOfUse")}
                  </Link>
                </span>
                <span className={styles.about_text}>
                  <Link className={styles.link} to="/privacy-policy">
                    {t("footer.privacyPolicy")}
                  </Link>
                </span>
                <span className={styles.about_text}>
                  <Link className={styles.link} to="/refund-policy">
                    {t("footer.refundPolicy")}
                  </Link>
                </span>
                <span className={styles.about_text}>
                  <Link className={styles.link} to="/payment-policy">
                    {t("footer.paymentPolicy")}
                  </Link>
                </span>
                <span className={styles.about_text}>
                  <Link className={styles.link} to="/aup">
                    {t("footer.aup")}
                  </Link>
                </span>
                <span className={styles.about_text}>
                  <Link className={styles.link} to="/cookies">
                    {t("footer.cookies")}
                  </Link>
                </span>
              </p>
            </div>
          </section>
          <section className={styles.footer_socials}>
            <h3 style={{ textAlign }}>{t("footer.social")}</h3>
            <div className={styles.footer_socials_icons}>
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className={styles.socialIconLink}
                aria-label={t("contact.email")}
              >
                <FaEnvelope className={styles.socialIconSvg} />
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIconLink}
                aria-label="Instagram"
              >
                <FaInstagram className={styles.socialIconSvg} style={{ color: "#E4405F" }} />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIconLink}
                aria-label={t("contact.whatsapp")}
              >
                <FaWhatsapp className={styles.socialIconSvg} style={{ color: "#25D366" }} />
              </a>
            </div>
          </section>
        </div>
        <p className={`text-center ${styles.copyright}`}>
          <AiOutlineCopyrightCircle aria-hidden style={{ flexShrink: 0 }} />
          {t("footer.allRightsReserved")}
        </p>
      </section>
    </footer>
  );
};

export default Footer;
